import React from "react";
import ProductsList from "../../components/LicenseManagement/ProductsList";
import { useLocation } from "react-router-dom";

function LicenseManagement() {
  const location = useLocation();
  var selectedStudentId = location.state
    ? location.state.studentId
    : 0;
  var selectedClassName = location.state
    ? location.state.className
    : "";

  return (
    <ProductsList studentId={selectedStudentId} className={selectedClassName} />
  );
}

export default LicenseManagement;
